import { TranscriptEditor } from "./Components/TranscriptEditor";
import { SpeakerEditor } from "./Components/SpeakerList";
import { UploadDataMeeting } from "./Components/UploadDataMeeting";
import styles from "./styles.module.css";
import classNames from "classnames";
import { useStorageSelectors } from "../../../../app/state/storageObjectSlice/hook/use-storage-selectors";

export const Transcript = () => {
  const { selectedObject } = useStorageSelectors("meetings");
  return (
    <div
      className={classNames(
        styles.container,
        !selectedObject?.write && styles.disabled,
      )}
    >
      <UploadDataMeeting />
      <SpeakerEditor />
      <TranscriptEditor />
    </div>
  );
};
